import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3BatterySettings } from 'ngx-modbus';

export const BATTERY_CONFIG_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'battery-config-settings',
  name: 'Battery Configuration',
  /**
   * BAT_CONFIG_ID acts as a battery-slot selector (1-4).
   * `applyMode: 'immediate'` writes the new ID on selection change, triggering
   * a section re-read so the form shows the address/protocol of the selected slot.
   * `alwaysIncludeInSectionWrites` ensures the ID register is prepended to every
   * batch write (contiguous Modbus address requirement).
   */
  modeSelector: {
    registerKey: 'BAT_CONFIG_ID',
    key: 'BAT_CONFIG_ID',
    labelKey: 'batteryConfigID',
    registerTable: 'V3BatterySettings',
    alwaysIncludeInSectionWrites: true,
    applyMode: 'immediate',
  },
  sections: [{
    id: 'battery-settings',
    labelKey: 'batteryConfiguration',
    registerTable: 'V3BatterySettings',
    controlRegister: 'BAT_CONFIG_CONTROL',
    validityMask: 'AddressMask_Config_Basic2',
    fields: [
      fieldRef(V3BatterySettings, 'BAT_CONFIG_PROTOCOL'),
      fieldRef(V3BatterySettings, 'BAT_CONFIG_ADDRESS_1', {
        labelKey: 'batteryCommunicationAddress1',
        fieldType: 'select',
        crossFieldTransform: {
          name: 'batteryAddress',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
        },
        dynamicOptions: {
          name: 'batteryAddressOptions',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
          config: { addressIndex: 1 },
        },
      }),
      fieldRef(V3BatterySettings, 'BAT_CONFIG_ADDRESS_2', {
        labelKey: 'batteryCommunicationAddress2',
        fieldType: 'select',
        crossFieldTransform: {
          name: 'batteryAddress',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
        },
        dynamicOptions: {
          name: 'batteryAddressOptions',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
          config: { addressIndex: 2 },
        },
      }),
      fieldRef(V3BatterySettings, 'BAT_CONFIG_ADDRESS_3', {
        labelKey: 'batteryCommunicationAddress3',
        fieldType: 'select',
        crossFieldTransform: {
          name: 'batteryAddress',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
        },
        dynamicOptions: {
          name: 'batteryAddressOptions',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
          config: { addressIndex: 3 },
        },
      }),
      fieldRef(V3BatterySettings, 'BAT_CONFIG_ADDRESS_4', {
        labelKey: 'batteryCommunicationAddress4',
        fieldType: 'select',
        crossFieldTransform: {
          name: 'batteryAddress',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
        },
        dynamicOptions: {
          name: 'batteryAddressOptions',
          dependencies: ['BAT_CONFIG_ID', 'BAT_CONFIG_PROTOCOL'],
          config: { addressIndex: 4 },
        },
      }),
      fieldRef(V3BatterySettings, 'BAT_CONFIG_CURRENT_CHARGE_LIMIT'),
      fieldRef(V3BatterySettings, 'BAT_CONFIG_CURRENT_DISCHARGE_LIMIT'),
      fieldRef(V3BatterySettings, 'BAT_DEPTH_OF_DISCHARGE'),
      fieldRef(V3BatterySettings, 'BAT_END_OF_DISCHARGE'),
    ],
  }],
};
